import {
  GET_RECIPES_LOADING,
  GET_RECIPES_LOADING_RESET,
  GET_RECIPES,
  RECIPE_COUNT,
  GET_SINGLE_RECIPE,
} from '../actions/types';

const initialState = {
  recipes: [] as any[],
  recipeCount: 0,
  loading: false,
  recipe: {} as any,
};

function reducer(state = initialState, action: { type: string; payload?: any }) {
  switch (action.type) {
    case GET_SINGLE_RECIPE:
      return {
        ...state,
        recipe: action.payload,
      };
    case RECIPE_COUNT:
      return {
        ...state,
        recipeCount: action.payload,
      };
    case GET_RECIPES:
      return {
        ...state,
        recipes: action.payload,
      };
    case GET_RECIPES_LOADING:
      return {
        ...state,
        loading: true,
      };
    case GET_RECIPES_LOADING_RESET:
      return {
        ...state,
        loading: false,
      };

    default:
      return state;
  }
}

export default reducer;
